import script from "./SalesChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./SalesChart.vue?vue&type=script&setup=true&lang=ts"

import "./SalesChart.vue?vue&type=style&index=0&id=c88a7c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c88a7c2c"]])

export default __exports__